import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Package, Wallet, LogOut, Boxes, Banknote, ShoppingCart, ShoppingBag, Coins, Settings } from "lucide-react";

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "nav-dashboard" },
  { to: "/uang", label: "Uang Saya", icon: Banknote, testId: "nav-uang" },
  { to: "/kas", label: "Kas & Transaksi", icon: Wallet, testId: "nav-kas" },
  { to: "/stok", label: "Stok Barang", icon: Package, testId: "nav-stok" },
  { to: "/penjualan", label: "Penjualan", icon: ShoppingCart, testId: "nav-penjualan" },
  { to: "/pembelian", label: "Pembelian", icon: ShoppingBag, testId: "nav-pembelian" },
  { to: "/laba", label: "Laba", icon: Coins, testId: "nav-laba" },
  { to: "/pengaturan", label: "Pengaturan", icon: Settings, testId: "nav-pengaturan" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="app-layout">
      <aside className="fixed left-0 top-0 w-64 h-screen bg-white border-r border-slate-200 p-6 flex-col gap-2 hidden md:flex z-40" data-testid="sidebar">
        <div className="flex items-center gap-3 px-2 pb-6 border-b border-slate-100 mb-4">
          <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center">
            <Boxes className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-heading font-bold text-slate-900 leading-tight">AzaliciaPos</p>
            <p className="text-xs text-slate-400">Kas • Stok • Laba</p>
          </div>
        </div>
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={item.testId}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200 ${
                isActive
                  ? "bg-indigo-50 text-indigo-600"
                  : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
              }`
            }
          >
            <item.icon className="w-4 h-4" />
            {item.label}
          </NavLink>
        ))}
        <div className="mt-auto pt-4 border-t border-slate-100">
          <div className="px-2 mb-3">
            <p className="text-sm font-semibold text-slate-800" data-testid="sidebar-username">{user?.username}</p>
            <p className="text-xs text-slate-400">{user?.email}</p>
          </div>
          <button
            data-testid="logout-button"
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-rose-50 hover:text-rose-600 transition-colors duration-200"
          >
            <LogOut className="w-4 h-4" />
            Keluar
          </button>
        </div>
      </aside>

      <div className="md:ml-64">
        <nav className="md:hidden bg-white border-b border-slate-200 px-3 py-2 flex items-center gap-2 sticky top-0 z-40" data-testid="mobile-nav">
          <div className="flex items-center gap-2 shrink-0">
            <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center">
              <Boxes className="w-4 h-4 text-white" />
            </div>
            <span className="font-heading font-bold text-slate-900 text-sm" data-testid="mobile-brand">AzaliciaPos</span>
          </div>
          <div className="flex items-center overflow-x-auto ml-auto">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-${item.testId}`}
                title={item.label}
                className={({ isActive }) =>
                  `p-1.5 rounded-lg transition-colors shrink-0 ${isActive ? "bg-indigo-50 text-indigo-600" : "text-slate-500"}`
                }
              >
                <item.icon className="w-5 h-5" />
              </NavLink>
            ))}
            <button data-testid="mobile-logout-button" onClick={handleLogout} title="Keluar" className="p-1.5 rounded-lg text-slate-500 hover:text-rose-600 transition-colors shrink-0">
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </nav>
        <main className="p-6 md:p-8 max-w-7xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
